<div class="portal-page-container container-fluid">
  <div class="row no-gutters">
    <app-side-menu [isCollapsed]="toggle" (toggleCollapse)="toggleMenu($event)"></app-side-menu>
    <div class="col portal-page position-relative">
      <app-header-bar (toggleMenu)="toggleMenu($event)" (mobileMenuToggle)="onMobileMenuToggle($event)"></app-header-bar>
      <div class="research-content-wrapper">
        <div>
          <ul>
            <li [routerLinkActive]="['active-route']" style="width: 25%" routerLink="/research-portal/stocks/overview">
              <i routerLink="/analytical/stocks/summary-financials"></i>
              <i routerLink="/research-portal/stocks/historical-data"></i>
              <i routerLink="/analytical/stocks/peer-comparison"></i>
              <i routerLink="/analytical/stocks/corporate-announcement"></i>
              <span>Stocks<i class="fa fa-arrow-right"></i></span>
            </li>
            <li [routerLinkActive]="['active-route']" style="width: 25%" routerLink="/research-portal/market-insights" class="sectors">
              <span>Market Insights<i class="fa fa-arrow-right"></i></span>
            </li>
            <li [routerLinkActive]="['active-route']" style="width: 25%" routerLink="/research-portal/dsc-dashboard" class="valuation-metrics">
              <span>DSC Dashboard<i class="fa fa-arrow-right"></i></span>
            </li>
<!--            <li-->
<!--              [routerLinkActive]="['active-route']"-->
<!--              style="width: 25%"-->
<!--              routerLink="/research-portal/sector-valuation-metrics"-->
<!--              class="valuation-metrics"-->
<!--            >-->
<!--              <span>Sector Valuation Metrics<i class="fa fa-arrow-right"></i></span>-->
<!--            </li>-->
          </ul>
        </div>
        <div class="col-12">
          <router-outlet></router-outlet>
        </div>
      </div>
      <div class="scroll-top" (click)="scrollUp()" [ngClass]="showScroll ? 'show' : 'hide'">
        <i class="fas fa-angle-down icon-lg pointer"></i>
      </div>
    </div>
  </div>
</div>

<div class="mobile-menu-backdrop" (click)="closeMobileMenu()"></div>
